export const priceInTradeRange = (price, range) => {
    if (!range)
        return true;
    return price >= range.priceLow && price <= range.priceHigh;
};
export const timeInTradeRange = (timeSec, range) => {
    if (!range)
        return true;
    if (range.timeFrom != null && timeSec < range.timeFrom)
        return false;
    // inclusive end: at timeTo the box expires (same as rangeBoundaryExit)
    if (range.timeTo != null && timeSec >= range.timeTo)
        return false;
    return true;
};
export const inTradeRange = (price, timeSec, range) => priceInTradeRange(price, range) && timeInTradeRange(timeSec, range);
/** Price-band touch only (ignores time). Used for market exits on lastPrice. */
export const rangePriceTouchExit = (side, price, range) => {
    if (!range || !Number.isFinite(price))
        return null;
    // long: high=TP low=SL; short: low=TP high=SL; no side → treat as band touch
    if (!side) {
        if (price >= range.priceHigh)
            return 'take_profit';
        if (price <= range.priceLow)
            return 'stop_loss';
        return null;
    }
    if (side === 'long') {
        if (price >= range.priceHigh)
            return 'take_profit';
        if (price <= range.priceLow)
            return 'stop_loss';
    }
    else {
        if (price <= range.priceLow)
            return 'take_profit';
        if (price >= range.priceHigh)
            return 'stop_loss';
    }
    return null;
};
export const rangeTimeExpired = (timeSec, range) => {
    if (!range || range.timeTo == null)
        return false;
    return timeSec >= range.timeTo;
};
/**
 * True when the strategy window is about to end — blink UI / tooltip.
 * Warn within 3 bars of timeTo (min 60s).
 */
export const rangeTimeEndingSoon = (range, nowSec, timeframeSec) => {
    if (!range || range.timeTo == null || !Number.isFinite(range.timeTo)) {
        return { soon: false, leftSec: Infinity };
    }
    const leftSec = range.timeTo - nowSec;
    if (leftSec <= 0)
        return { soon: true, leftSec: 0 };
    const warnWindow = Math.max(60, Math.max(1, timeframeSec) * 3);
    return { soon: leftSec <= warnWindow, leftSec };
};
export const rangeBoundaryExit = (side, price, timeSec, range) => {
    if (!range)
        return null;
    if (rangeTimeExpired(timeSec, range))
        return 'time_expired';
    return rangePriceTouchExit(side, price, range);
};
